// removed by extract-text-webpack-plugin
module.exports = {"navRow":"Catalog--navRow--2ldBeJjJ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/events/Views/Catalog/Catalog.css
// module id = 1332
// module chunks = 2